import React from 'react'
import { observer } from 'mobx-react'
import BookkeepingSelectCycleViewModel from './BookkeepingSelectCycleDialogViewModel'
import { BookkeepingCycle } from 'jobs/bookkeeping/BookkeepingProgressionInfo'
import Button from 'components/Button'
import Icon from 'components/Icon'
import {
  formatCycleCompletedItems,
  formatCycleCompletionDate,
} from './formatters'
import styles from './BookkeepingSelectCycleDialog.sass'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetTitle,
  ModalSheetHeaderDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'

interface BookkeepingSelectCycleDialogProps {
  vm: BookkeepingSelectCycleViewModel
}

export default observer(function BookkeepingSelectCycleDialog({
  vm,
}: BookkeepingSelectCycleDialogProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader shellSize="sm" withCloseButton></ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetTitle large>Select a cycle</ModalSheetTitle>
          <ModalSheetHeaderDescription>
            Choose the cycle you want to correct.
          </ModalSheetHeaderDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetContent>
        <CompletedCycleList vm={vm} />
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            type="default"
            onClick={vm.close}
            data-test="select-cycle-close-button"
          >
            Close
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

interface CompletedCycleListProps {
  vm: BookkeepingSelectCycleViewModel
}

const CompletedCycleList = observer(function CompletedCycleList({
  vm,
}: CompletedCycleListProps) {
  return (
    <div className={styles.cyclesList}>
      {vm.completedCycles?.map((cc) => (
        <CompletedCycleListItem
          key={cc.id}
          cycle={cc}
          onSelectCycle={vm.selectCycle}
        />
      ))}
    </div>
  )
})
interface CompletedCycleListItemProps {
  cycle: BookkeepingCycle
  onSelectCycle: (selectedCycle: BookkeepingCycle) => void
}

const CompletedCycleListItem = observer(function CompletedCycleListItem({
  cycle,
  onSelectCycle,
}: CompletedCycleListItemProps) {
  return (
    <div className={styles.cycleItem} onClick={() => onSelectCycle(cycle)}>
      <div className={styles.cycleItemInfo}>
        <div className={styles.title}>
          Cycle {cycle.number} ({formatCycleCompletionDate(cycle)})
        </div>
        <div className={styles.completedItems}>
          {formatCycleCompletedItems(cycle)}
        </div>
      </div>
      <div className={styles.arrowContainer}>
        <Icon className={styles.arrow} size={24} name="arrow" />
      </div>
    </div>
  )
})
